import Vue from 'vue';
import Vuex from 'vuex';

import Case from './module/case';
import Krpano from './module/krpano';
import user from './module/user';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
    //
    },
    mutations: {
    //
    },
    actions: {
    //
    },
    modules: {
        Case,
        Krpano,
        user
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js